import { TRUSTED } from "../../data";
import { useSiteContent } from "../../lib/content";

export default function Marquee() {
  const { content } = useSiteContent();
  const trusted = content.trusted?.length ? content.trusted : TRUSTED;
  const row = [...trusted, ...trusted];
  return (
    <section className="py-12 border-y border-border/10 overflow-hidden marquee-pause">
      <div className="mx-auto max-w-7xl px-6 mb-8">
        <p className="text-center text-xs uppercase tracking-[0.24em] text-muted-foreground">
          Trusted by corporates, startups &amp; institutions across 18 cities
        </p>
      </div>
      <div className="relative flex whitespace-nowrap">
        <div className="flex animate-marquee items-center">
          {row.map((name, i) => (
            <span key={i} className="mx-10 font-display text-2xl md:text-3xl font-bold text-muted-foreground/50 hover:text-gradient transition-colors">
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TaglineMarquee() {
  const words = ["Ideas.", "Strategy.", "Growth.", "Ideas.", "Strategy.", "Growth."];
  const row = [...words, ...words];
  return (
    <section className="py-16 overflow-hidden border-y border-border/10 bg-brand-gradient">
      <div className="relative flex whitespace-nowrap">
        <div className="flex animate-marquee-fast items-center">
          {row.map((w, i) => (
            <span key={i} className="mx-6 font-display text-5xl md:text-7xl font-extrabold text-white/95 tracking-tight">
              {w} <span className="text-white/40">✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
